"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProjectSettings = void 0;

var React = _interopRequireWildcard(require("react"));

var _Page = require("../Layout/Page");

var _ProjectsBox = _interopRequireDefault(require("./components/ProjectsBox"));

var _SettingsBox = _interopRequireDefault(require("./components/SettingsBox"));

var _ProjectSettings = require("./ProjectSettings.styles");

var _Foot = _interopRequireDefault(require("./components/Foot"));

var _RulesBox = _interopRequireDefault(require("./components/RulesBox"));

var _rules = require("../../context/settings/rules");

var _useProjectSettings = require("./hooks/useProjectSettings");

var _SavingOverlay = require("./components/SavingOverlay");

const ProjectSettings = props => {
  const {
    projectList,
    onSave
  } = props;
  const {
    ruleList
  } = (0, _rules.useRulesState)();
  const {
    handleProjectSelect,
    handleRuleSelect,
    selectedRule,
    activeProject,
    isSaving
  } = (0, _useProjectSettings.useProjectSettings)(projectList);
  React.useEffect(() => {
    if (isSaving) {
      onSave();
    }
  }, [isSaving]);
  return /*#__PURE__*/React.createElement(_Page.Wrap, null, /*#__PURE__*/React.createElement(_ProjectSettings.Frame, null, /*#__PURE__*/React.createElement(_ProjectSettings.ContentWrapper, null, isSaving && /*#__PURE__*/React.createElement(_SavingOverlay.SavingOverlay, null), /*#__PURE__*/React.createElement(_ProjectsBox.default, {
    projectList: projectList,
    onProjectSelect: handleProjectSelect,
    activeProject: activeProject
  }), /*#__PURE__*/React.createElement(_ProjectSettings.RulesBoxWrapper, null, /*#__PURE__*/React.createElement(_ProjectSettings.BoxHeader, null, /*#__PURE__*/React.createElement(_ProjectSettings.BoxHeading, null, "Insights")), ruleList != null && ruleList.length > 0 && /*#__PURE__*/React.createElement(_RulesBox.default, {
    ruleList: ruleList,
    selectedRule: selectedRule,
    onRuleSelect: handleRuleSelect,
    activeProject: activeProject
  })), /*#__PURE__*/React.createElement(_SettingsBox.default, {
    selectedRule: selectedRule
  })), /*#__PURE__*/React.createElement(_Foot.default, {
    activeProject: activeProject
  })));
};

exports.ProjectSettings = ProjectSettings;